import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import { getApps, initializeApp as initializeModularApp, getApp as getModularApp } from 'firebase/app'
import { getDatabase as getModularDatabase } from 'firebase/database'

// Shared by main.ts and the emulator build (e2e/emulator/admin/main.ts), which configures the emulators first.
export function prepareFirebase(firebaseConfig: object): void {
  // Ensure the compat app is initialized before AngularFire kicks in, so database() is available.
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
  }

  const defaultApp = firebase.app()
  const attachDatabase = (app: any) => {
    if (typeof app?.database !== 'function') {
      app.database = (url?: string) => getModularDatabase(app, url)
    }
  }
  attachDatabase(defaultApp)
  const defaultProto = (defaultApp as any).constructor?.prototype
  if (defaultProto && typeof defaultProto.database !== 'function') {
    defaultProto.database = (url?: string) => getModularDatabase(defaultApp, url)
  }
  getApps().forEach(attachDatabase)
  // Ensure modular singleton also exists so getApps() is populated even if compat initializes first.
  if (!getApps().length) {
    initializeModularApp(firebaseConfig)
  }
  const modularApp = getModularApp()
  attachDatabase(modularApp)
  const modularProto = (modularApp as any).constructor?.prototype
  if (modularProto && typeof modularProto.database !== 'function') {
    modularProto.database = (url?: string) => getModularDatabase(modularApp, url)
  }

  // Ensure any future firebase.app() calls also receive the fallback.
  const originalCompatApp = firebase.app.bind(firebase)
  ;(firebase as any).app = (...args: unknown[]) => {
    const appInstance = originalCompatApp(...args)
    attachDatabase(appInstance)
    return appInstance
  }

  // Minimal runtime diagnostics to catch Firebase init issues during e2e/dev runs.
  if (!(window as any).__FIREBASE_INIT_LOGGED__) {
    ;(window as any).__FIREBASE_INIT_LOGGED__ = true
    // eslint-disable-next-line no-console
    console.log('[FirebaseCompat]', {
      hasDatabase: typeof (firebase as any).database === 'function',
      appHasDatabase: typeof (defaultApp as any).database === 'function',
      apps: firebase.apps?.map(a => ({ name: a.name })),
    })
  }
}
